const initialState = () => ({
  page: 1,
  collection_status: "",
  selected_tab: 0,
  display_daterange: "",
  date_range: [],
  initaited_by: "",
  city: "",
  executive_type: "",
  executive_name: "",
  product_type: "",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
